import Bowser from "bowser";
import setupProtoRoots from "src/browser/setupProtoRoots";
import { webLinks } from "src/browser/web-links";
import { setupI18nInBrowser } from "src/i18n/setupI18n";

export default async function browserSetup() {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isAppAvailable = browser.satisfies({
    chrome: ">=69",
    edge: ">=79",
    firefox: ">=76"
  });
  const hasUser = window.localStorage.getItem("parseUser");
  if (!isAppAvailable) {
    if (hasUser) window.open(webLinks.dashboardWebapp, "_self");
    else window.open(webLinks.login, "_self");
  }

  const opencvScript = document.createElement("script");
  opencvScript.src = "./opencv.js";
  opencvScript.async = true;
  document.body.appendChild(opencvScript);

  if (!Object.fromEntries) {
    Object.fromEntries = function (entries) {
      if (!entries || !entries[Symbol.iterator]) {
        throw new Error(
          "Object.fromEntries() requires a single iterable argument"
        );
      }
      let obj = {};
      for (let [key, value] of entries) {
        obj[key] = value;
      }
      return obj;
    };
  }
  const promises = [setupI18nInBrowser(), setupProtoRoots()];
  await Promise.all(promises);
}
